import React, { useRef } from 'react';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import metadata from './PolicySummaryRentedTDCComponent.metadata.json5';
import messages from './PolicySummaryRentedTDCComponent.messages';
import styles from './PolicySummaryRentedTDCComponent.module.scss';

function PolicySummaryRentedTDCComponent(props) {
    const {
        model: vehicles,
        isNamedNonOwner,
        data
    } = props;
    const translator = useTranslator();

    const renderVehicleTitle = () => {
        return (
            <h2 className="subsection-header">
                {translator(messages.summaryRentedTDCVehicles)}
            </h2>
        );
    };

    const getYearCellHeader = () => {
        return (
            <>
                <span className={styles.standardHeader}>{ translator(messages.summaryRentedTDCVehicleYear) }</span>
                <span className={styles.mobileHeader}>{ _.capitalize(translator(messages.summaryRentedTDCVehicleYear)) }:</span>
            </>
        )
    };

    const getMakeCellHeader = () => {
        return (
            <>
                <span className={styles.standardHeader}>{ translator(messages.summaryRentedTDCVehicleMake) }</span>
                <span className={styles.mobileHeader}>{ _.capitalize(translator(messages.summaryRentedTDCVehicleMake)) }:</span>
            </>
        )
    };

    const getModelCellHeader = () => {
        return (
            <>
                <span className={styles.standardHeader}>{ translator(messages.summaryRentedTDCVehicleModel) }</span>
                <span className={styles.mobileHeader}>{ _.capitalize(translator(messages.summaryRentedTDCVehicleModel)) }:</span>
            </>
        )
    };


    const getSerialNoCellHeader = () => {
        return (
            <>
                <span className={styles.standardHeader}>{ translator(messages.summaryRentedTDCVehicleSerialNo) }</span>
                <span className={styles.mobileHeader}>{ _.capitalize(translator(messages.summaryRentedTDCVehicleSerialNo)) }:</span>
            </>
        )
    };

    const getYearCell = (item) => {
        return <span className={ styles.vehicleBoldCellValue }>{ item?.year?.value }</span>;
    };

    const getMakeCell = (item) => {
        return <span className={ styles.vehicleBoldCellValue }>{ item?.make?.value }</span>;
    };

    const getModelCell = (item) => {
        return <span className={ styles.vehicleCellValue }>{ item?.model?.value }</span>;
    };


    const getSerialNoCell = (item) => {
        return <span className={ styles.vehicleBoldCellValue }>{ item?.serial_ML?.value }</span>;
    };

    const rentedTDCList = data
        .map(v => v.rentedTDCVehicles_ML)
        .filter(item =>
            item &&
            (
                item.make ||
                item.model ||
                item.serial_ML ||
                item.year
            )
        );

    const overrideProps = {
        rentedTDCTableContainer: {
            visible: rentedTDCList.length > 0
        },
        rentedTDCTable: {
            data: rentedTDCList,
            visible: rentedTDCList.length > 0,
            renderTitle: renderVehicleTitle,
        },
    };


    const resolvers = {
        resolveCallbackMap: {
            getYearCellHeader: getYearCellHeader,
            getMakeCellHeader: getMakeCellHeader,
            getModelCellHeader: getModelCellHeader,
            getSerialNoCellHeader: getSerialNoCellHeader,
            getYearCell: getYearCell,
            getMakeCell: getMakeCell,
            getModelCell: getModelCell,
            getSerialNoCell: getSerialNoCell
        },
        resolveComponentMap: {
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={vehicles}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={styles}
        />
    );
}

PolicySummaryRentedTDCComponent.propTypes = {
    model: PropTypes.shape([]).isRequired,
    gpaMode:PropTypes.bool,
    isPolicyChange: PropTypes.bool
};
PolicySummaryRentedTDCComponent.defaultProps = {
    gpaMode: false,
    isPolicyChange: true
};

export default PolicySummaryRentedTDCComponent;
